export default {
  queryEquips: '/v3/new/equip/checkRecord'// '/v3/equip/queryEquips'
}
